import * as angular from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class WalletsRequests {

  /* @ngInject */
  constructor(private apiConfig: ApiConfig, private $walletsBalances,
              private WalletsBalancesAPI) {
  }

  getAgentsTotalBalance() {
    const api = this.WalletsBalancesAPI.actions.getTotalBalance;
    return this.$$call(api, {}, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params?, _data?, _options?) {
    return this.$walletsBalances().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.wallets')
  .service('walletsRequests', WalletsRequests);
